import React from 'react';
import numberFormatter from '../../utils/numberFormatter.js';
import NumberRounding from '../../utils/numberRounding.js';
import IDSExportButton from './IDSExportButton.jsx';
import SpotplanIDSExportButton from './SpotplanIDSExportButton.jsx';
import PanelIDSExportButton from './PanelIDSExportButton.jsx';
import PanelService from '../../services/panelService';
import * as consts from '../../models/consts.js'
import QueryStringService from '../../services/queryStringService.js';

const CONST_SPOTPLAN_SPOTLENGTH = 5;
const CONST_CAMPAIGN_NAME_GBG = 'göteborg'
const CONST_CAMPAIGN_NAME_STHLM = 'stockholm'
const CONST_CAMPAIGN_NAME_TRANSIT = 'transit'
const CONST_CAMPAIGN_NAME_MALMO = 'malmö'
const CONST_CAMPAIGN_NAME_SKANE = 'skåne'
const CONST_CAMPAIGN_NAME_NATIONAL = 'national'
const CONST_CAMPAIGN_NAME_BIGCITY = 'big city'

export default class CampaignSummaryPlay extends React.Component {
    constructor() {
        super();
        let queryStringService = new QueryStringService();
        this.country = queryStringService.getCurrentCountry();
        this.state = {
        };
    }

    validateSovAgainstList(sov) {
        if (this.props.parameters.idsValidSoVValues) {
            if (this.props.parameters.idsValidSoVValues.includes(sov)) {
                return true
            }
        }
        return false
    }

    shouldShow() {
        return Array.from(arguments).includes(this.country);
    }

    render() {
        let target = null;
        let campaignPromise = this.props.campaignPackagePromise
        let notStarted = this.props.campaignInfo.notStarted
        const targetSov = NumberRounding.round(this.props.selectedOrderLines[0].targetSoV * 100.0, 2);
        const targetSoVWithoutRounding = this.props.selectedOrderLines[0].targetSoV;
        const targetScreens = this.props.selectedOrderLines[0].targetScreens;
        const goalMultiplier = this.props.parameters.playSuccessLimit / 100.0;
        let deliveredSov = this.props.campaignInfo.soV;

        // Elements, finetexts and table combinations
        let showFineTextOver = false
        let fineTextOver = ''
        let fineTextOverColWidth = 9
        let fineTextOver2 = ''
        let showFineTextUnder = false
        let fineTextUnder = ''
        let showFineTextSeparator = false

        let showVACImported = false
        let vacImportedLabel = 'VAC Contacts' + (this.shouldShow(consts.Countries.se,consts.Countries.no) ? '*' : '' );
        let showVACOld = false

        let showReach = false
        let showFrequency = false
        let showScreens = false
        let showPlays = false
        let showSoV = false

        let idsReachValue = this.props.campaignInfo.idsReach
        let idsAverageFrequencyValue = this.props.campaignInfo.idsAverageFrequency
        let idsRegionValues = this.props.campaignInfo.idsImportedValuesFromExcel
        let campaignName = this.props.campaignName

        //Buttons
        let showIDSresultExportButton = false
        let showPanelIDSExportButton = false
        let showSpotPlanToIDSButton = false

        const campaignHasEnded = !notStarted && moment(this.props.dataFetchedInUTC).format('YYYY-MM-DD') > moment(this.props.campaignInfo.periodEnd).format('YYYY-MM-DD');
        let enableSpotPlanToIDSButton = this.validateSovAgainstList(targetSov) && campaignHasEnded;
        let enablePanelIDSExportButton = false
        let showCampaignPerformance = false
        let showScreensInSov = false
        let soVscreens = this.props.campaignInfo.screensThatMatchPromisedSoV
        let deliveredScreens = this.props.campaignInfo.notStarted ? 0 : this.props.campaignInfo.screens;
        let useNewSoVCalculation = moment(this.props.campaignInfo.periodStart).format('YYYY-MM-DD') >= moment(this.props.parameters.clientSettings.newSOVCalculationFrom).format('YYYY-MM-DD');

        switch (campaignPromise) {
            case consts.CampaignPromisePackings.sovp:
                enablePanelIDSExportButton = campaignHasEnded;
                showPanelIDSExportButton = true
                showSpotPlanToIDSButton = true
                showSoV = true
                deliveredSov = (this.props.selectedData.panels.reduce((acc, val) => { return acc + (val.soV * 100); }, 0) / targetScreens) / 100;
                showFineTextOver = this.shouldShow(consts.Countries.se, consts.Countries.no);
                fineTextOver2 = this.props.parameters.clientSettings.customStrings.campaignSummary.sovPFineTextOver;
                fineTextOverColWidth = 12
                showFineTextSeparator = true
                break;
            case consts.CampaignPromisePackings.sov:
                showScreensInSov = true
                enablePanelIDSExportButton = campaignHasEnded;
                showSpotPlanToIDSButton = false
                showIDSresultExportButton = true
                showPanelIDSExportButton = true
                showSpotPlanToIDSButton = true
                showVACImported = true
                vacImportedLabel = 'VAC Contacts IDS'+ (this.shouldShow(consts.Countries.se,consts.Countries.no) ? '*' : '' );
                showCampaignPerformance = true
                showReach = true
                showFrequency = true
                if (idsRegionValues !== null) {
                    if (moment(this.props.campaignInfo.periodEnd).format('YYYY-MM-DD') >=
                        moment(this.props.parameters.clientSettings.idsUseNationalStart).format('YYYY-MM-DD')) {
                        idsReachValue = idsRegionValues.national["reach"]
                        idsAverageFrequencyValue = idsRegionValues.national["averageFrequency"]
                    }
                    else if (campaignName.toLowerCase().includes(CONST_CAMPAIGN_NAME_GBG)){
                        idsReachValue = idsRegionValues.goteborg["reach"]
                        idsAverageFrequencyValue = idsRegionValues.goteborg["averageFrequency"]
                    }
                    else if (campaignName.toLowerCase().includes(CONST_CAMPAIGN_NAME_STHLM)) {
                        idsReachValue = idsRegionValues.stockholm["reach"]
                        idsAverageFrequencyValue = idsRegionValues.stockholm["averageFrequency"]
                    }
                    else if (campaignName.toLowerCase().includes(CONST_CAMPAIGN_NAME_TRANSIT)) {
                        idsReachValue = idsRegionValues.stockholm["reach"]
                        idsAverageFrequencyValue = idsRegionValues.stockholm["averageFrequency"]
                    }
                    else if (campaignName.toLowerCase().includes(CONST_CAMPAIGN_NAME_MALMO)) {
                        idsReachValue = idsRegionValues.malmo["reach"]
                        idsAverageFrequencyValue = idsRegionValues.malmo["averageFrequency"]
                    }
                    else if (campaignName.toLowerCase().includes(CONST_CAMPAIGN_NAME_SKANE)) {
                        idsReachValue = idsRegionValues.malmo["reach"]
                        idsAverageFrequencyValue = idsRegionValues.malmo["averageFrequency"]
                    }
                    else if (campaignName.toLowerCase().includes(CONST_CAMPAIGN_NAME_NATIONAL)) {
                        idsReachValue = idsRegionValues.national["reach"]
                        idsAverageFrequencyValue = idsRegionValues.national["averageFrequency"]
                    }
                    else if (campaignName.toLowerCase().includes(CONST_CAMPAIGN_NAME_BIGCITY)) {
                        idsReachValue = idsRegionValues.stockholm["reach"] + idsRegionValues.goteborg["reach"] + idsRegionValues.malmo["reach"]
                        idsAverageFrequencyValue = idsRegionValues.stockholm["averageFrequency"] + idsRegionValues.goteborg["averageFrequency"] + idsRegionValues.malmo["averageFrequency"]
                    }
                }

                showFineTextOver = this.shouldShow(consts.Countries.se,consts.Countries.no);
                fineTextOver = this.props.parameters.clientSettings.customStrings.campaignSummary.sovFineTextOver;
                fineTextOver2 = this.props.parameters.clientSettings.customStrings.campaignSummary.sovFineTextOver2;
                if (this.props.extraValueValue > 0) {
                    fineTextUnder = this.props.parameters.clientSettings.customStrings.campaignSummary.sovFineTextUnder;
                    showFineTextUnder =  this.shouldShow(consts.Countries.se,consts.Countries.no);
                }

                if (this.props.campaignInfo.idsTarget !== null && this.props.campaignInfo.idsTarget !== "")
                    target = this.props.campaignInfo.idsTargetRaw;
                break;

            case consts.CampaignPromisePackings.fxp:
                enablePanelIDSExportButton = campaignHasEnded;
                showPanelIDSExportButton = true
                showSpotPlanToIDSButton = true
                showVACOld = true
                showFineTextOver = this.shouldShow(consts.Countries.se,consts.Countries.no);
                fineTextOver = this.props.no97Fxp ? this.props.parameters.clientSettings.customStrings.campaignSummary.fxpFineTextOverNo97 : this.props.parameters.clientSettings.customStrings.campaignSummary.fxpFineTextOver;
                if (this.props.extraValueValue > 0) {
                    showFineTextUnder = this.shouldShow(consts.Countries.se);
                    fineTextUnder = this.props.parameters.clientSettings.customStrings.campaignSummary.fxpFineTextUnder;
                }
                fineTextOverColWidth = 12
                target = this.props.selectedOrderLines[0].targetVAC;
                break;

            case consts.CampaignPromisePackings.flexai:
                enablePanelIDSExportButton = campaignHasEnded;
                showPanelIDSExportButton = true
                showSpotPlanToIDSButton = true
                showScreens = true
                if (soVscreens && soVscreens.length == 'undefined') {deliveredScreens =  0}
                else {deliveredScreens =  soVscreens}
                showFineTextOver = this.shouldShow(consts.Countries.se, consts.Countries.no);
                fineTextOver = this.props.parameters.clientSettings.customStrings.campaignSummary.flexaiFineTextOver;
                fineTextOverColWidth = 12
                fineTextOver2 = this.props.parameters.clientSettings.customStrings.campaignSummary.flexaiFineTextOver2;
                showFineTextSeparator = true
                target = this.props.selectedOrderLines[0].targetScreens;
                break;

            case consts.CampaignPromisePackings.sovd:
                enablePanelIDSExportButton = campaignHasEnded;
                showScreens = true;
                showFineTextOver = false;
                fineTextOver = this.props.parameters.clientSettings.customStrings.campaignSummary.flexaiFineTextOver;
                fineTextOverColWidth = 12;
                fineTextOver2 = this.props.parameters.clientSettings.customStrings.campaignSummary.flexaiFineTextOver2;
                showFineTextSeparator = true;
                target = this.props.selectedOrderLines[0].targetScreens;
                break;

            
            case consts.CampaignPromisePackings.vac:
                showVACOld = true
                showFineTextOver = this.shouldShow(consts.Countries.se, consts.Countries.no);
                fineTextOver = this.props.parameters.clientSettings.customStrings.campaignSummary.vacFineTextOver;
                fineTextOverColWidth = 12
                target = this.props.selectedOrderLines[0].targetVAC;
                break;

            case consts.CampaignPromisePackings.sfi:
                showPlays = true
                target = this.props.selectedOrderLines[0].targetPlays;
                break;
            default:
                target = this.props.selectedOrderLines[0].targetVAC;
                break;
        }

        let plays = this.props.campaignInfo.plays
        let vacContacts = this.props.campaignInfo.vacContacts
        const idsExportFileExists = this.props.campaignInfo.idsExportFileExists;
        const idsExportFileVAC = this.props.campaignInfo.idsVac;
        let soVScreenList = PanelService.getPanelsForFxpBeforeCutoffDate(targetSoVWithoutRounding, this.props.parameters.playSuccessLimit / 100.0,
            this.props.parameters.soVNumberOfDecimals, this.props.selectedData.panels, useNewSoVCalculation);
        if (this.props.shouldUseFxpDeliveryFix && !this.props.no97Fxp) {
            soVScreenList = PanelService.getPanelsThatMatchesTargetSoV(targetSoVWithoutRounding, this.props.parameters.playSuccessLimit / 100.0,
                this.props.parameters.soVNumberOfDecimals, this.props.selectedData.panels, useNewSoVCalculation);
            vacContacts = soVScreenList.reduce((acc, val) => { return acc + val.deliveredDouble; }, 0).toFixed(0);
        }

        function handleCampaignStatus(deliveredScreens, panels, no97Fxp) {
            if (notStarted) {return 'Not started'}
            if (!campaignHasEnded) { return 'Ongoing' }
            switch (campaignPromise) {
                case consts.CampaignPromisePackings.sfi: {
                    let division = plays / target;
                    if (!Number.isFinite(division))
                        division = 0;

                    let playsDeliveredPercentage = numberFormatter.numberAsPercent(division);
                    if (division.toFixed(2) >= goalMultiplier && target > 0) {
                        if (playsDeliveredPercentage) { return 'Delivered (' + playsDeliveredPercentage + ')' }
                        return 'Delivered'
                    }
                    return 'Not Delivered (' + playsDeliveredPercentage + ')'
                }
                case consts.CampaignPromisePackings.vac: {
                    let division = vacContacts / target;
                    if (!Number.isFinite(division))
                        division = 0;
                    let vacDeliveredPercentage = numberFormatter.numberAsPercent(division)
                    if (division.toFixed(2) >= goalMultiplier && target > 0) {
                        if (vacDeliveredPercentage) { return 'Delivered (' + vacDeliveredPercentage + ')' }
                        return 'Delivered'
                    }
                    return 'Not Delivered (' + vacDeliveredPercentage + ')'
                }
                case consts.CampaignPromisePackings.fxp: {
                    let division = vacContacts / target;
                    if (!Number.isFinite(division))
                        division = 0;
                    let vacDeliveredPercentage = numberFormatter.numberAsPercent(division)
                    if (division.toFixed(2) >= goalMultiplier && target > 0) {
                        if (vacDeliveredPercentage) { return 'Delivered (' + vacDeliveredPercentage + ')' }
                        return 'Delivered'
                    }

                    return 'Not Delivered (' + vacDeliveredPercentage + ')'
                }
                case consts.CampaignPromisePackings.flexai: {
                    let division = deliveredScreens / targetScreens;
                    if (!Number.isFinite(division))
                        division = 0;

                    let screensDeliveredPercentage = numberFormatter.numberAsPercent(division);
                    if (division.toFixed(2) >= goalMultiplier && targetScreens > 0) {
                        if (screensDeliveredPercentage) { return 'Delivered (' + screensDeliveredPercentage + ')' }
                        return 'Delivered'
                    }
                    return 'Not Delivered (' + screensDeliveredPercentage + ')'
                }
                case consts.CampaignPromisePackings.sovd: {
                    let division = panels.length / targetScreens;
                    if (!Number.isFinite(division))
                        division = 0;

                    let screensDeliveredPercentage = numberFormatter.numberAsPercent(division);
                    if (division.toFixed(2) >= goalMultiplier && targetScreens > 0) {
                        if (screensDeliveredPercentage) { return 'Delivered (' + screensDeliveredPercentage + ')' }
                        return 'Delivered'
                    }
                    return 'Not Delivered (' + screensDeliveredPercentage + ')'
                }
                case consts.CampaignPromisePackings.sovp: {
                    let division = deliveredSov / targetSoVWithoutRounding;
                    if (!Number.isFinite(division))
                        division = 0;

                    let soVDeliveredPercentage = numberFormatter.numberAsPercent(division);
                    if (division.toFixed(2) >= goalMultiplier) {
                        if (soVDeliveredPercentage) { return 'Delivered (' + soVDeliveredPercentage + ')' }
                        return 'Delivered'
                    }
                    return 'Not Delivered (' + soVDeliveredPercentage + ')'
                }
                case consts.CampaignPromisePackings.sov: {
                    if (!idsExportFileExists || target == null) { return 'Awaiting data' }

                    let convertedTarget = 0;
                    if (target !== null && target !== "")
                        convertedTarget = +target;

                    let showPercentage = (idsExportFileVAC / (convertedTarget === 0 ? 1 : convertedTarget)).toFixed(2)
                    let importedVacDeliveredPercentage = numberFormatter.numberAsPercent(showPercentage);
                    if (showPercentage >= goalMultiplier && convertedTarget > 0) {
                        if (importedVacDeliveredPercentage) { return 'Delivered (' + importedVacDeliveredPercentage + ')' }
                        return 'Delivered'
                    }
                    return 'Not Delivered (' + importedVacDeliveredPercentage + ')'
                }
                default:
                    return ''
            }
        }

        return (
            <div>
                <div className={'campaign-summary-promises2 play-background'}>
                    <div style={{'width': '100%', 'float': 'left', 'paddingBottom': '18px'}}>
                        <div className={'.float-sm-right'}>
                            <h3 style={{'float': 'left', 'textAlign':'left' }}>Campaign status</h3>
                        </div>
                        <div className="text-right text-md-left">
                            <h3 style={{'float': 'right', 'textAlign':'right', 'paddingRight': '18px' }}>{handleCampaignStatus(deliveredScreens, this.props.selectedData.panels, this.props.no97Fxp)}</h3>
                        </div>
                    </div>

                    <div style={{'paddingBottom': '10px'}}>
                        <table style={{'width': '100%'}}>
                            <tbody>
                                <tr>
                                    <th>Campaign promise</th>
                                    <th>Promised</th>
                                    <th>Delivered</th>
                                </tr>

                                {showScreens &&
                                    <tr>
                                        <td className="table-cell-btm-padding">Screen(s){this.shouldShow(consts.Countries.se) && <span>*</span>}</td>
                                        <td className="table-cell-btm-padding">{targetScreens}</td>
                                        <td className="table-cell-btm-padding">{deliveredScreens}</td>
                                    </tr>
                                }
                                {showSoV &&
                                    <tr>
                                        <td className="table-cell-btm-padding">Share of Voice (SOV){this.shouldShow(consts.Countries.se) && <span>*</span>}                                        
                                        </td>
                                        <td className="table-cell-btm-padding">{numberFormatter.numberWithOneDecAndProcent(targetSoVWithoutRounding)}</td>
                                        <td className="table-cell-btm-padding pop-tooltip">{numberFormatter.numberWithOneDecAndProcent(deliveredSov)}
                                            <span class="pop-tooltiptext">Accumulated SOV                                                
                                                <hr style={{ 'marginTop': '0', 'marginBottom': '0', 'marginLeft': '10px', 'marginRight': '10px' }}></hr>
                                                Promised screens
                                            </span>
                                        </td>
                                    </tr>
                                }
                                {showVACImported &&
                                    <tr>
                                        <td className="table-cell-btm-padding">{vacImportedLabel}</td>
                                        <td className="table-cell-btm-padding">{(target !== null && target !== "") ? numberFormatter.numberWithSpaces(+target) : 'Awaiting data'}</td>
                                        <td className="table-cell-btm-padding">{this.props.campaignInfo.idsExportFileExists ? numberFormatter.numberWithSpaces(this.props.campaignInfo.idsVac) : 'Awaiting data'}</td>
                                    </tr>
                                }

                                {showCampaignPerformance &&
                                    <tr>
                                        <th>Campaign Performance IDS</th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                }

                                {showReach &&
                                    <tr>
                                        <td>Reach{this.shouldShow(consts.Countries.se,consts.Countries.no) && <span>*</span>}</td>
                                        <td> </td>
                                        <td>{this.props.campaignInfo.idsExportFileExists ? numberFormatter.numberWithSpaces(idsReachValue) : 'Awaiting data[nr/%]'}</td>
                                    </tr>
                                }

                                {showFrequency &&
                                    <tr>
                                        <td>Frequency{this.shouldShow(consts.Countries.se,consts.Countries.no) && <span>*</span>}</td>
                                        <td> </td>
                                        <td>{this.props.campaignInfo.idsExportFileExists ? numberFormatter.numberRoundedWithSpaces(idsAverageFrequencyValue) : 'Awaiting data[nr]'}</td>
                                    </tr>
                                }
                                {showScreensInSov &&
                                    <tr>
                                        <td>Screens{this.shouldShow(consts.Countries.se,consts.Countries.no) && <span>*</span>}</td>
                                        <td> </td>
                                        <td>{this.props.campaignInfo.idsExportFileExists ? numberFormatter.numberWithSpaces(soVscreens) : 'Awaiting data'}</td>
                                    </tr>
                                }
                                {showVACOld &&
                                    <tr>
                                        <td className="table-cell-btm-padding">{vacImportedLabel}</td>
                                        <td className="table-cell-btm-padding">{numberFormatter.numberWithSpaces(target)}</td>
                                        <td className="table-cell-btm-padding">{numberFormatter.numberWithSpaces(vacContacts)}</td>
                                    </tr>
                                }
                                {showPlays &&
                                    <tr>
                                        <td className="table-cell-btm-padding">Plays</td>
                                        <td className="table-cell-btm-padding">{numberFormatter.numberWithSpaces(target)}</td>
                                        <td className="table-cell-btm-padding">{numberFormatter.numberWithSpaces(plays)}</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="row" style={{display:'flex', flexFlow: 'wrap', justifyContent:'space-between'}}>
                    <div className={'col-md-' + fineTextOverColWidth}>
                        <div style={{'paddingLeft': '0px', 'paddingRight': '20px', 'textAlign': 'left', 'width': '100%', 'fontStyle': 'italic', 'fontSize': 8}}>
                            {showFineTextOver &&
                                <div>
                                 {fineTextOver}
                                </div>
                            }
                            {showFineTextSeparator && <div style={{'whiteSpace': 'pre-line'}}></div>}
                            <br/>
                            {fineTextOver2}
                            {showFineTextSeparator && <div style={{'whiteSpace': 'pre-line'}}></div>}
                            <br/>
                        </div>

                    </div>

                    {showIDSresultExportButton &&
                        <div className="w100-if-xs">
                            <div style={{'display': 'inline-block', 'float': 'right'}}>
                                    <IDSExportButton
                                        allowIDSExport={this.props.campaignInfo.idsExportFileExists}
                                        orderlineid={this.props.selectedOrderLines[0].id}
                                        campaignName={this.props.campaignName}
                                        showLoadingIcon={true}/>
                            </div>
                        </div>
                    }

                    { showSpotPlanToIDSButton && showPanelIDSExportButton &&
                        <div className="col-md-12">

                            <div style={{'display': 'inline-block', 'float': 'left', 'paddingRight': '20px', 'width': '47%'}}>
                                <div style={{'paddingTop': '10px', 'textAlign': 'left', 'fontStyle': 'italic', 'fontSize': 8}}>
                                    {(showFineTextUnder ? fineTextUnder : '')}
                                </div>
                            </div>

                            <div style={{'float': 'right', 'width': '53%'}}>
                                <div style={{'display': 'inline-block', 'float': 'right'}}>
                                    {showSpotPlanToIDSButton &&
                                        <SpotplanIDSExportButton
                                        allowSpotplanExport={enableSpotPlanToIDSButton}
                                        spotlength={CONST_SPOTPLAN_SPOTLENGTH}
                                        targetSoV={targetSov}
                                        campaignName={this.props.campaignName}
                                        showLoadingIcon={true}
                                        style={{ marginTop: '2px', marginLeft: '10px', minWidth: "140px" }}
                                    />
                                    }
                                </div>

                                <div style={{'display': 'inline-block', 'float': 'right'}}>
                                    {showPanelIDSExportButton &&
                                        <PanelIDSExportButton
                                        allowExport={enablePanelIDSExportButton}
                                        useIDSExportFormat={enablePanelIDSExportButton}
                                        considerSoVWhenExportingIDSPanels={true}
                                        targetSoV={targetSoVWithoutRounding}
                                        panels={this.props.selectedData.panels}
                                        campaignType={this.props.selectedCampaignType}
                                        campaignName={this.props.campaignName}
                                        label={'Face ID list to IDS' + (this.shouldShow(consts.Countries.se, consts.Countries.no) ? '*' : '')}
                                        SoVFaultTolerance={goalMultiplier}
                                        SoVNoOfDecimals={this.props.parameters.soVNumberOfDecimals}
                                        periodStart={this.props.campaignInfo.periodStart}
                                        newSOVCalculationFrom={this.props.parameters.clientSettings.newSOVCalculationFrom}
                                        style={{ marginTop: '2px', width: '140px' }}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

